"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.leadSubmissionLMPApi = void 0;
var leadSubmissionLMPApi = /** @class */ (function () {
    function leadSubmissionLMPApi(local, handleLeadSubmission) {
        this.props = local;
        this.handleLeadSubmission = handleLeadSubmission;
    }
    leadSubmissionLMPApi.prototype.getCookie = function (name) {
        var cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURI(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    };
    leadSubmissionLMPApi.prototype.submitLead = function (bookAppointment) {
        if (bookAppointment === void 0) { bookAppointment = false; }
        return __awaiter(this, void 0, void 0, function () {
            var submissionModel, requestOptions, apiSuccess;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        submissionModel = {
                            "leadId": this.props.values.LeadId,
                            "brand": "AVL",
                            "agentCode": this.props.values.agentCode,
                            "calendarTitle": "",
                            "calendarLocation": "",
                            "CalendarAppointmentDate": this.props.values.appointmentDateString,
                            "CalendarAppointmentTime": this.props.values.appointmentTimeString.split(" ")[0],
                            "CalendarAppointmentTimeOfDay": this.props.values.appointmentTimeString.split(" ")[1],
                            "CalendarDuration": "1 hour",
                            "calendarUserName": "",
                            "calendarSalesPersonId": "",
                            "calendarDetail": "",
                            "calendarURL": "",
                            "allocationId": this.props.values.agentAllocationId,
                            "originAddress": this.props.values.movingFromAddrComponent.MovingFromAddress,
                            "originCity": this.props.values.movingFromAddrComponent.MovingFromCity,
                            "originState": this.props.values.movingFromAddrComponent.MovingFromState,
                            "originZipcode": this.props.values.movingFromAddrComponent.MovingFromZip,
                            "__RequestVerificationToken": this.props.values.verificationToken
                        };
                        if (bookAppointment) {
                            submissionModel = {
                                "leadId": this.props.values.LeadId,
                                "brand": "AVL",
                                "agentCode": this.props.values.agentCode,
                                "calendarTitle": "",
                                "calendarLocation": "",
                                "CalendarAppointmentDate": this.props.values.appointmentDateString,
                                "CalendarAppointmentTime": this.props.values.appointmentTimeString.split(" ")[0],
                                "CalendarAppointmentTimeOfDay": this.props.values.appointmentTimeString.split(" ")[1],
                                "CalendarDuration": "1 hour",
                                "calendarUserName": "",
                                "calendarSalesPersonId": "",
                                "calendarDetail": "",
                                "calendarURL": "",
                                "allocationId": this.props.values.agentAllocationId,
                                "originAddress": this.props.values.movingFromAddrComponent.MovingFromAddress,
                                "originCity": this.props.values.movingFromAddrComponent.MovingFromCity,
                                "originState": this.props.values.movingFromAddrComponent.MovingFromState,
                                "originZipcode": this.props.values.movingFromAddrComponent.MovingFromZip,
                                "__RequestVerificationToken": this.props.values.verificationToken
                            };
                        }
                        console.log("****************Submission Model");
                        console.log(JSON.stringify(submissionModel));
                        requestOptions = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json; charset=utf-8',
                                'x-api-key': 'IbxeqEcmkQ52cE4burH3kqczlSCY9Wvr',
                                'X-Requested-With': 'XMLHttpRequest'
                            },
                            body: JSON.stringify(submissionModel)
                            //body: new URLSearchParams(submissionModel)
                        };
                        console.log("Starting SubmitAppointment the API Call");
                        apiSuccess = false;
                        return [4 /*yield*/, fetch('/CustomApi/OnlineAppointmentBooking/SubmitAppointment', requestOptions)
                                .then(function (response) {
                                console.log("**************After Fetch RESPONSE**********************");
                                console.log(JSON.stringify(response));
                                if (!response.ok) {
                                    throw new Error('error => Error while Submitting Lead');
                                }
                                return response.json();
                            })
                                .then(function (data) {
                                if (bookAppointment) {
                                    console.log("******Return DATA*****");
                                    console.log(JSON.stringify(data));
                                    _this.handleLeadSubmission(data);
                                }
                                apiSuccess = true;
                            }, function (error) {
                                if (bookAppointment) {
                                    _this.handleLeadSubmission(error);
                                }
                                apiSuccess = false;
                            })
                                .catch(function (error) {
                                console.log(error);
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, apiSuccess];
                }
            });
        });
    };
    return leadSubmissionLMPApi;
}());
exports.leadSubmissionLMPApi = leadSubmissionLMPApi;
//# sourceMappingURL=leadSubmissionLMPApi.js.map